import { render, staticRenderFns } from "./WalletBarnerCompnent.vue?vue&type=template&id=ffce413c&scoped=true&"
import script from "./WalletBarnerCompnent.vue?vue&type=script&lang=js&"
export * from "./WalletBarnerCompnent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce413c",
  null
  
)

export default component.exports